import { EpsiDocStatesEnum as EPSI_STATE } from '../../openapi/types/EpsiDocStatesEnum';

export { EPSI_STATE };

/**
 * Fáze stahování — soubory ještě neexistují a BE na ně vrací ACL 403,
 * takže se nesmí nabízet stahování příloh.
 */
export const EPSI_DOWNLOAD_STATES: readonly EPSI_STATE[] = [
  EPSI_STATE.WAITING_FOR_DOWNLOAD,
  EPSI_STATE.DOWNLOADING,
  EPSI_STATE.DOWNLOAD_FAILED,
];

export const isEpsiDownloadPhase = (state?: EPSI_STATE) =>
  !!state && EPSI_DOWNLOAD_STATES.includes(state);

/**
 * Stavy, ze kterých má smysl nabízet ruční retry — selhání, ze kterých se sada
 * sama nedostane. `WAITING_FOR_DOWNLOAD` retry sice podle BE také přijme, ale
 * tam se ještě čeká na cron a tlačítko by jen svádělo k předbíhání.
 */
export const EPSI_RETRY_STATES: readonly EPSI_STATE[] = [
  EPSI_STATE.DOWNLOAD_FAILED,
  EPSI_STATE.IMPORT_FAILED,
];

export const isEpsiRetryable = (state?: EPSI_STATE) =>
  !!state && EPSI_RETRY_STATES.includes(state);

/**
 * Jak dlouho zůstane výsledek retry viset pod řádkem, než sám zhasne. Sada se
 * mezitím obvykle přepne do dalšího stavu, takže hláška ztrácí platnost.
 */
export const EPSI_RETRY_DISMISS_DELAY = 10000;

/**
 * Počet sloupců přehledu — drží šířku rozbaleného řádku s výsledkem retry.
 * Při změně hlavičky v `Epsi.tsx` je potřeba upravit i tady.
 */
export const EPSI_LIST_COLUMN_COUNT = 8;

/** Sloučení dávky SSE zpráv do jednoho refetche přehledu. */
export const SSE_REFETCH_DELAY = 500;

/** Aby se přehled obnovoval i během souvislého proudu zpráv. */
export const SSE_REFETCH_MAX_WAIT = 3000;
